export enum ModelApiKey {
  Index = 'index',
  Page = 'page',
  Article = 'article',
  Work = 'work',
  Job = 'job'
}
